import { hPost } from '@mcfe/tools';

/**
 * 根据名字查询相似的 CSPU
 * 接口文档：https://api-mall.sankuai.com/main/api-doc-v4/detail?projectId=580&apiId=106533&branch=master
 */
// eslint-disable-next-line import/prefer-default-export
export async function searchSimilarityCspuByName(name) {
    let list = [];
    if (!name?.trim()) return list;
    try {
        list = await hPost(
            '/api/vss/shepherd/industry/CspuInfoTService/searchSimilarityCspuByName',
            { name },
        );
    } catch (e) {
        console.error('请求相似同品接口 searchSimilarityCspuByName 失败:', e?.message, e);
    }
    return list;
}
